export const ultimasNoticias = [
    /*{
        "imagen" : "https://s-seguridad.hidalgo.gob.mx/assets/imgs/transparencia_2023.jpeg",
        "url" : "https://s-seguridad.hidalgo.gob.mx/assets/pdf/Convocatoria_2023.pdf",
        "titulo" : "Concurso Nácional Transparencia en Corto 2023",
        "fecha" : "¡Revisa la convovatoria!"
    },*/
    /*{
        "imagen" : "https://s-seguridad.hidalgo.gob.mx/assets/imgs/policiaestatal02.jpg",
        "url" : "https://s-seguridad.hidalgo.gob.mx/assets/pdf/convEstatal202401.pdf",
        "titulo" : "Convocatoria Policía Estatal",
        "fecha" : "26 de Febrero al 15 de Abril de 2024"
    },
    {
        "imagen" : "https://s-seguridad.hidalgo.gob.mx/assets/imgs/penitenciaria.jpg",
        "url" : "https://s-seguridad.hidalgo.gob.mx/assets/pdf/convPenitenciaria202401.pdf",
        "titulo" : "Convocatoria Policía Penitenciaria",
        "fecha" : "12 de Febrero al 15 de Mayo de 2024"
    },*/
    {
        "imagen" : "https://s-seguridad.hidalgo.gob.mx/assets/imgs/CODIGO_H_banner.jpg",
        "url" : "https://s-seguridad.hidalgo.gob.mx/assets/imgs/Codigo-H.png",
        "titulo" : "Código H",
        "fecha" : "Permanente"
    },
    {
        "imagen" : "https://s-seguridad.hidalgo.gob.mx/assets/imgs/seguridadPrivada.jpeg",
        "url" : "https://s-seguridad.hidalgo.gob.mx/Privada",
        "titulo" : "Seguridad Privada",
        "fecha" : "Contactanos"
    }
   
]